import { createFileRoute } from "@tanstack/react-router";
import { redirectRemovedAuthor } from "@/lib/removedAuthors";
import { loadContentMeta, buildContentHead } from "@/lib/seo/contentHead";
import AuthorRedirect from "@/components/LegacyRedirects";

export const Route = createFileRoute("/es/author/$slug")({
  loader: ({ params }) => (redirectRemovedAuthor(params.slug, "/es"), loadContentMeta("authors", params.slug, "es")),
  head: ({ params, loaderData }) =>
    buildContentHead(`/es/author/${params.slug}`, loaderData),
  component: AuthorRedirect,
});

